export function getUrlParams(searchUrl: string): {params: any} {
  const urlSearchParams = new URLSearchParams(searchUrl);
  return {
    params: Object.fromEntries(urlSearchParams.entries()),
  };
}
